
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo/face-verification-api",
      function () {
        return require("private-next-pages/demo/face-verification-api.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo/face-verification-api"])
      });
    }
  